// URLs aus API-Daten nur same-origin verwenden. Avatare können von Webhook-Aufrufern (avatar_url) stammen –
// externe Bilder wären Tracking-Pixel (IP/Zeitpunkt jedes Betrachters); die Prod-CSP blockt sie ohnehin.
// Medien liefert der Server unter /api/media/… aus, Exporte unter /api/exports/… .

/** Gibt die URL zurück, wenn sie http(s) und same-origin (oder relativ) ist, sonst null. */
export function sameOriginUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  try {
    const origin = window.location.origin;
    const parsed = new URL(url, origin);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
    return parsed.origin === origin ? url : null;
  } catch {
    return null;
  }
}
